module.exports = __webpack_public_path__ + "media/images/icons/icn_016-d9a96e52646b06224cce3749ab6216f3.svg";